import React from "react";

const FancyTextBlockThree = ({ keyfeature }) => {
  return (
    <div className="row no-gutters">
      <div className="col-lg-6">
        <div className="feature-content  d-flex align-items-center justify-content-center flex-column light-bg">
          <div className="feature-list d-flex">
            <div className="icon-box d-flex align-items-center justify-content-center">
              <img src={keyfeature.icon} alt="icon" className="p-1" />
            </div>
            <div className="text-meta ps-2">
              <h3 className="h3-heading text-start text-white">
                {keyfeature.name}{" "}
              </h3>
              <p className="h3-para">{keyfeature.description} </p>
            </div>
            {/* /.text-meta */}
          </div>
          {/* /.feature-list */}
          <div className="feature-list d-flex">
            <div className="icon-box d-flex align-items-center justify-content-center">
              <img src={keyfeature.icon2} alt="icon2" className="p-1" />
            </div>
            <div className="text-meta ps-2">
              <h3 className="h3-heading text-start text-white">
                {keyfeature.name2}
              </h3>
              <p className="h3-para lh-base">{keyfeature.description2}</p>
            </div>
          </div>
          {keyfeature.name3 && (
            <div className="feature-list d-flex">
              <div className="icon-box d-flex align-items-center justify-content-center">
                <img src={keyfeature.icon3} alt="icon3" className="p-1" />
              </div>
              <div className="text-meta">
                <h3 className="h3-heading text-start text-white">
                  {" "}
                  {keyfeature.name3}
                </h3>
                <p className="h3-para lh-base ">{keyfeature.description3} </p>
              </div>
            </div>
          )}
        </div>
        {/* /.feature-content */}
      </div>
      <div className="col-lg-6">
        <div className="feature-content dark-bg d-flex align-items-center justify-content-center flex-column">
          <div className="feature-list d-flex">
            <div className="icon-box d-flex align-items-center justify-content-center">
              <img src={keyfeature.icon4} alt="icon4" className="p-1" />
            </div>
            <div className="text-meta ps-2">
              <h3 className="text-black h3-heading text-start">
                {keyfeature.name4}
              </h3>
              <p className="text-black h3-para lh-base">
                {keyfeature.description4}{" "}
              </p>
            </div>
          </div>
          {/* /.feature-list */}
          <div className="feature-list d-flex">
            <div className="icon-box d-flex align-items-center justify-content-center">
              <img src={keyfeature.icon5} alt="icon5" className="p-1" />
            </div>
            <div className="text-meta ps-2">
              <h3 className="text-black h3-heading text-start">
                {keyfeature.name5}{" "}
              </h3>
              <p className="text-black h3-para lh-base">
                {keyfeature.description5}
              </p>
            </div>
            {/* /.text-meta */}
          </div>

          {keyfeature.name6 && (
            <div className="feature-list d-flex">
              <div className="icon-box d-flex align-items-center justify-content-center">
                <img src={keyfeature.icon6} alt="icon6" className="p-1" />
              </div>
              <div className="text-meta ps-2">
                <h3 className="h3-heading text-start">{keyfeature.name6}</h3>
                <p className="h3-para lh-base text-black">{keyfeature.description6}</p>
              </div>
            </div>
          )}
        </div>{" "}
      </div>
    </div>
  );
};

export default FancyTextBlockThree;
